<template>
  <div class="experience-vip-receive">
    <ym-popup class="experience-vip-receive-popup"
              v-model="visible"
              :close-on-click-overlay="closeOnClickOverlay"
              get-container="body"
              position="top"
    >
      <div class="experience-vip-receive-container">
        <div class="experience-vip-receive-header">{{ title }}</div>
        <verify-mobile @submit-action="handleSubmitAction"
        />
        <div class="experience-vip-receive-submit-btn"
             :class="{ 'disabled': submitBtnDisabled }"
             @click="handleSubmit"
        ></div>
        <div class="experience-vip-receive-hint">
          点击免费领取表示您已阅读并同意
          <router-link class="link"
                       :to="{ name: 'UserTerm' }"
          >
            《服务协议》
          </router-link>
        </div>
      </div>
      <div class="experience-vip-receive-popup-close"
           @click.stop="handleClose(visible)"
      >
        <ym-icon name="round-close" />
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';
  import VerifyMobile from '@/pages/MillionRead/components/ExperienceVipVerifyMobile';

  export default {
    name: 'ExperienceVipReceivePopup',
    components: {
      'ym-popup': Popup,
      VerifyMobile,
    },
    data() {
      return {
        visible: false,
        submitBtnDisabled: false,
        params: null,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true,
      },
      needMobile: {
        type: Boolean,
        required: true,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
      needMobile(val) {
        this.submitBtnDisabled = val;
      },
    },
    methods: {
      handleSubmitAction(params) {
        this.submitBtnDisabled = !params;
        this.params = params;
      },
      handleSubmit() {
        this.$emit('submit-action', this.params);
      },
      handleClose() {
        this.visible = false;
      },
    },
    created() {
      this.submitBtnDisabled = this.needMobile;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .experience-vip-receive {
    &-popup {
      background: transparent;
    }
    &-container {
      box-sizing: border-box;
      width: 690px;
      height: 786px;
      margin: 100px auto 0;
      padding-top: 250px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: url('~@/assets/img/million_read/welfare/receive_popup_bg.png') no-repeat;
      background-size: 100% 100%;
    }
    &-header {
      margin-bottom: 34px;
      color: #b32a00;
      font-size: 48px;
      font-weight: @font-weight-strong;
      line-height: 1;
    }
    &-submit-btn {
      width: 282px;
      height: 88px;
      margin-bottom: @size-small;
      background: url('~@/assets/img/million_read/welfare/receive_popup_btn.png') no-repeat;
      background-size: 100% 100%;
      &.disabled {
        opacity: .6;
      }
    }
    &-hint {
      color: #ffe5de;
      font-size: @font-size-extra-small;
      line-height: 1;
    }
    &-popup-close {
      position: absolute;
      bottom: -2 * @size-extra-medium;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: @size-large;
      height: @size-large;
      font-size: @size-large;
      color: @color-placeholder;
    }
  }
</style>
